import { render, staticRenderFns } from "./VeterinaryPrescription.vue?vue&type=template&id=31351c0a&scoped=true"
import script from "./VeterinaryPrescription.vue?vue&type=script&lang=js"
export * from "./VeterinaryPrescription.vue?vue&type=script&lang=js"
import style0 from "./VeterinaryPrescription.vue?vue&type=style&index=0&id=31351c0a&prod&lang=css"
import style1 from "./VeterinaryPrescription.vue?vue&type=style&index=1&id=31351c0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31351c0a",
  null
  
)

export default component.exports